<template>
  <div>
    <app-echart-stacked-area
      id="echart"
      :option-data="option"
    />
  </div>
</template>
<script>
import echarts from 'echarts/lib/echarts'
import getFormattedDate, { getFormattedDateTime } from '@/utils/date-formatter'
import AppEchartStackedArea from '@core/components/charts/echart/AppEchartStackedArea.vue'

export default {
  components: {
    AppEchartStackedArea,
  },
  props: {
    rows: {
      type: Array,
      default: null,
    },
    range: {
      type: [Array, String],
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      getFormattedDate,
      getFormattedDateTime,
      myChart: null,
      option: {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: {
          type: 'line',
          areaStyle: {},
          data: [],
        },
      },
    }
  },
  watch: {
    type() {
      this.myChart.dispatchAction(this.option)
    },
  },
  created() {
    this.fetchCampaignDate()
    this.fetchCampaignStatistics()
  },
  mounted() {
    this.myChart = echarts.init(document.querySelector('#echart'))
    this.myChart.setOption(this.option)
  },
  methods: {
    fetchCampaignDate() {
      const xAxisData = []
      if (this.type === 'month' || this.type === 'week' || this.type === 'custom') {
        this.rows.forEach(element => {
          const datetime = getFormattedDate(new Date(element.datetime))
          xAxisData.push(datetime)
        })
      } else if (this.type === 'day') {
        this.rows.forEach(element => {
          const datetime = getFormattedDateTime(new Date(element.datetime))
          xAxisData.push(datetime)
        })
      }
      this.option.xAxis.data = xAxisData
    },
    fetchCampaignStatistics() {
      const impressions = this.rows.map(item => (item.impressions))
      this.option.series.data = impressions
    },
    findDayDifference(date1, date2) {
      return Math.floor((Math.abs(date2 - date1)) / (1000 * 60 * 60 * 24))
    },
  },
}
</script>
<style scoped>
.echarts {
  width: 100% !important
}
</style>
